'use client'

import './globals.css'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { ReactNode } from 'react'
import { useEffectOnce } from 'react-use'

const queryClient = new QueryClient()

export default function RootLayout ({
  children
}: Readonly<{
  children: ReactNode
}>): JSX.Element {
  useEffectOnce(() => {
    // If at any moment, any element has the scrollbar-lock="true" attribute
    // these classes will prevent the body to scroll
    // Usefull when displaying modals, drawers, flyouts
    document.body.style.setProperty('--scrollbar-width', getScrollbarWidth())
    document.body.classList.add('has-[[scrollbar-lock="true"]]:overflow-hidden', 'has-[[scrollbar-lock="true"]]:pr-[--scrollbar-width]')
  })

  return (
    <QueryClientProvider client={queryClient}>
      <html lang='en' className='min-h-screen accent-primary'>
        <title>FlexSelect Admin</title>
        <body className='text-gray-800 min-h-screen w-full overflow-y-scroll has-[[data-pointer-events-lock="true"]]:pointer-events-none'>
          {children}
          <ReactQueryDevtools initialIsOpen={false} />
        </body>
      </html>
    </QueryClientProvider>
  )
}

function getScrollbarWidth (): string {
  const div = document.createElement('div')
  div.style.width = '100px'
  div.style.height = '100px'
  div.style.overflow = 'scroll'
  div.style.position = 'absolute'
  div.style.top = '-9999px'
  document.body.appendChild(div)
  const scrollbarWidth = div.offsetWidth - div.clientWidth
  document.body.removeChild(div)
  return String(scrollbarWidth) + 'px'
}
